import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading"; // @ts-ignore
import wolfgangOle from "../images/wolfgang-ole.jpg";
import format from "date-fns/format";
import { de } from 'date-fns/locale';
import Pagination from "../components/common/pagination";
var PodcastsPage = function PodcastsPage(_ref) {
    var pageContext = _ref.pageContext, location = _ref.location;
    var podcasts = pageContext.podcasts, pageNumber = pageContext.pageNumber, pageCount = pageContext.pageCount, lastEpisode = pageContext.lastEpisode;
    var basePath = "podcasts";
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Wohlstand f\xFCr alle"
    }), location.pathname === "/podcasts/" && /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "bg-black mb-6 text-white lg:mb-8"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: "Wohlstand f\xFCr Alle"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2 px-4 pb-6 flex flex-wrap relative lg:px-8"
    }, /*#__PURE__*/ React.createElement("img", {
        src: wolfgangOle,
        alt: "Wohlstand f\xFCr Alle",
        className: "absolute left-0 bottom-0 hidden lg:block lg:w-64"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-xl pt-4 pb-4 lg:w-3/12 lg:text-2xl lg:pb-64"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "font-bold"
    }, "Podcast " + lastEpisode.type + (lastEpisode.type == "Ep" ? ". " : " ") + lastEpisode.number), format(new Date(lastEpisode.publishDate), "dd. MMMM yyyy", {
        locale: de
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full h0 font-medium text-3xl normal-line-height pb-4 lg:pr-8 lg:text-5xl lg:w-4/12"
    }, lastEpisode.title, /*#__PURE__*/ React.createElement("audio", {
        controls: true,
        className: "mt-4 lg:mt-12"
    }, lastEpisode.mp3.map(function (e, i) {
        return /*#__PURE__*/ React.createElement("source", {
            src: e.url,
            type: e.type,
            key: i
        });
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full content-text lg:w-5/12 lg:pl-4"
    }, /*#__PURE__*/ React.createElement("p", null, lastEpisode.description)))), /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: "Alle Episoden"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, podcasts.map(function (ep, i) {
        var podcastType = (ep.type !== "Ep" ? ep.type + " " : "Ep. ") + ep.number;
        return /*#__PURE__*/ React.createElement("div", {
            className: "mb-8 w-full md:w-1/3 md:pr-4",
            key: i
        }, /*#__PURE__*/ React.createElement("a", {
            href: ep.link,
            target: "_blank"
        }, /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
            className: "mb-4 block truncate",
            title: podcastType
        }), /*#__PURE__*/ React.createElement("h3", {
            className: "text-2xl font-medium mt-3 mb-4"
        }, ep.title))));
    }))), /*#__PURE__*/ React.createElement(Pagination, {
        currentPage: pageNumber,
        pageCount: pageCount,
        basePath: basePath
    }));
};
export default PodcastsPage;
